<template>
  <div>
    <div class="form-group">
      <label>{{ labelText }}</label>
      <a-range-picker
        v-model="dateRange"
        :ranges="presetRanges"
        :show-time="{ format: 'HH:mm:ss', defaultValue: [defaultStartTime, defaultEndTime] }"
        format="YYYY-MM-DD HH:mm:ss"
        style="width: 100%"
        @change="onRangeChange"
      />
      <!-- Hidden inputs that go with the form -->
      <input type="hidden" :name="baseFieldStart" :value="hiddenStart">
      <input type="hidden" :name="baseFieldEnd" :value="hiddenEnd">
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'LogsDatePicker',
  props: {
    baseFieldStart: { type: String, required: true },
    baseFieldEnd: { type: String, required: true },
    initialStartDate: { type: [String, Date], default: null },
    initialEndDate: { type: [String, Date], default: null },
    labelText: { type: String, default: 'Date Range' },
  },
  data() {
    return {
      dateRange: [],
      hiddenStart: '',
      hiddenEnd: '',
    };
  },
  computed: {
    defaultStartTime() {
      return moment('00:00:00', 'HH:mm:ss');
    },
    defaultEndTime() {
      return moment('23:59:59', 'HH:mm:ss');
    },
    presetRanges() {
      const startOfDay = d => d.clone().startOf('day');
      const endOfDay = d => d.clone().endOf('day');

      return {
        Yesterday: [startOfDay(moment().subtract(1, 'day')), endOfDay(moment().subtract(1, 'day'))],
        'Last 7 Days': [startOfDay(moment().subtract(6, 'days')), endOfDay(moment())],
        'Last 14 Days': [startOfDay(moment().subtract(13, 'days')), endOfDay(moment())],
        'Last 30 Days': [startOfDay(moment().subtract(29, 'days')), endOfDay(moment())],
        'Last 90 Days': [startOfDay(moment().subtract(89, 'days')), endOfDay(moment())],
        'This Month': [startOfDay(moment().startOf('month')), endOfDay(moment().endOf('month'))],
        'Last Month': [
          startOfDay(moment().subtract(1, 'month').startOf('month')),
          endOfDay(moment().subtract(1, 'month').endOf('month')),
        ],
        'All Time': [startOfDay(moment('2000-01-01')), endOfDay(moment())],
      };
    },
  },
  watch: {
    initialStartDate: 'initializeRange',
    initialEndDate: 'initializeRange',
  },
  methods: {
    initializeRange() {
      const start = this.initialStartDate ? moment(this.initialStartDate) : null;
      const end = this.initialEndDate ? moment(this.initialEndDate) : null;

      this.dateRange = start && end ? [start, end] : [];
      this.updateHiddenValues();
    },
    updateHiddenValues() {
      this.hiddenStart = this.dateRange[0] ? this.dateRange[0].format('YYYY-MM-DD HH:mm:ss') : '';
      this.hiddenEnd = this.dateRange[1] ? this.dateRange[1].format('YYYY-MM-DD HH:mm:ss') : '';
    },
    onRangeChange(dates, dateStrings) {
      this.dateRange = dates;
      this.updateHiddenValues();

      this.$emit('input', {
        [this.baseFieldStart]: dateStrings[0] || null,
        [this.baseFieldEnd]: dateStrings[1] || null,
      });
    },
  },
  mounted() {
    this.initializeRange();
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/LogsDatePicker.vue